import React from "react";
import { Form, Message, Popup, Icon, Button } from "semantic-ui-react";
import CheckboxFilter from "../elements/CheckboxFilter";

function NonProfit(props) {
  const { nonProfits, values, valid, beneficiaries, beneficiary_enabled } = props;
  const rules = {
    nonprofit_id: "required|min:1",
    beneficiaries: "beneficiary_selected"
  };
  const customMessages = {
    "min.nonprofit_id": "A non-profit must be selected"
  };
  props.setRules(rules, customMessages);
  return (
    <Form size="large" error={valid.errorCount > 0}>
      <Message
        error
        content={Object.keys(valid.errors.all()).map((item, key) => {
          return (
            <span key={key}>
              {valid.errors.first(item)}
              <br />
            </span>
          );
        })}
      />
      <Form.Select
        name="event.nonprofit_id"
        label="Choose a Non-profit"
        options={nonProfits}
        value={values.nonprofit_id}
        onChange={props.handleChange}
        autoComplete="off"
      />
      {beneficiary_enabled && !values.is_import_raffle &&
        <Form.Radio
          toggle
          size="large"
          label={+values.beneficiaryenabled === 1 ? <label><span><Icon name="heartbeat" color="green" fitted /></span> Beneficiaries Enabled</label> : <label><span><Icon name="heartbeat" color="red" fitted /></span> Beneficiaries Disabled</label>}
          value={+values.beneficiaryenabled}
          name="event.beneficiaryenabled"
          className="radioToggleBtn"
          checked={+values.beneficiaryenabled === 1}
          onChange={props.handleChange}
        />}
      {beneficiary_enabled && +values.beneficiaryenabled === 1 &&
        <Form.Field>
          <label>
            <Popup
              trigger={
                <span>
                  <Icon name="help circle" color="blue" fitted /> Select Beneficiaries
              </span>
              }
              content="Choosing from the list of beneficiaries now will allow you to select one or more beneficiaries during E-Commerce "
              inverted
              wide
            />
          </label>
          <CheckboxFilter
            name="event.beneficiaries"
            options={beneficiaries}
            value={values.beneficiaries}
            onChange={props.handleChange}
          />
        </Form.Field>
      }

      <Button
        type="button"
        primary
        size="large"
        content="Save And Continue"
        onClick={() => props.handleStep(`${values.is_import_raffle ? 'verify' : 'sales'}`)}
        floated="right"
      />
      <Button
        type="button"
        size="large"
        content="Go Back"
        onClick={() => props.handleStep("games")}
        floated="right"
      />

    </Form>
  );
}

export default NonProfit;
